/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ level: NonNullable<unknown>, percent: NonNullable<unknown> }} Audit_Logs_Compliance_StatusInputs */



/**
* | output |
* | --- |
* | "{level}, {percent}% confidence" |
*
* @param {Audit_Logs_Compliance_StatusInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_logs_compliance_status = /** @type {((inputs: Audit_Logs_Compliance_StatusInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Logs_Compliance_StatusInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.level}, ${i?.percent} % Konfidenz`)
	return /** @type {LocalizedString} */ (`${i?.level}, ${i?.percent}% confidence`)
});